import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
// import en from 'react-phone-input-2/lang/en.json'
import fr from 'react-phone-input-2/lang/fr.json'
import { useContext } from 'react'
import { LanguageContext } from '../../context'

const PhoneCustomInput = ({ value, onChange, inputProps }) => {

  const localizations = {
    // en: en,
    fr: fr,
  }

  const { t, currentLanguage } = useContext(LanguageContext)

  return (
    <>
      <PhoneInput
        country={'be'}
        value={value}
        onChange={onChange}
        enableSearch={true}
        inputProps={inputProps}
        searchPlaceholder={t('phone_input.search')}
        localization={localizations[currentLanguage] || null}
      />
    </>
  )
}

export default PhoneCustomInput
